import type React from 'react';

import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { DetailsContainer } from '../containers/Details';
import { useIsSunriseEnabled } from '../hooks/isSunriseEnabled';

import { useShowSurvey } from './hooks/useShowSurvey';
import { useTrackPageView } from './hooks/useTrackPageView';

export const Layout: React.FC = () => {
	useTrackPageView();
	useShowSurvey();

	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();

	return (
		<DesignSystemLegacy theme={isSunriseEnabled ? sunriseTheme : undefined}>
			<DetailsContainer />{' '}
		</DesignSystemLegacy>
	);
};
